import React from 'react';
import {
    Flex,
    IconButton,
    ButtonGroup,
    Text,
} from '@chakra-ui/react';
import { 
    MdMyLocation, 
} from 'react-icons/md';
import { FiPlus, FiMinus } from 'react-icons/fi';

interface MapControlsProps {
    isSatellite: boolean;
    onToggleSatellite: () => void;
    onFocusToArea: () => void;
    onZoomIn: () => void;
    onZoomOut: () => void;
}

export const MapControls: React.FC<MapControlsProps> = ({
    isSatellite,
    onToggleSatellite,
    onFocusToArea,
    onZoomIn,
    onZoomOut,
}) => {
    return (
        <Flex
            position="absolute"
            bottom={{ base: "15%", sm: 6, md: 8 }}
            right={{ base: 4, sm: 6, md: 8 }}
            direction="column"
            gap={2}
            zIndex={10}
        >
            {/* Toggle Satellite Button */}
            <IconButton
                aria-label="Toggle Satelit"
                icon={<Text fontSize="x-small" fontWeight="bold">{isSatellite ? "Satelit" : "Peta"}</Text>}
                onClick={onToggleSatellite}
                variant="solid"
                colorScheme="blue"
                borderRadius="full"
                boxShadow="lg"
                w="40px"
                h="40px"
                display="flex"
                alignItems="center"
                justifyContent="center"
            />

            {/* Focus area Button */}
            <IconButton
                aria-label="Focus area"
                icon={<MdMyLocation size={20} />}
                onClick={onFocusToArea}
                variant="solid"
                colorScheme="blue"
                borderRadius="full"
                boxShadow="lg"
                w="40px"
                h="40px"
                display="flex"
                alignItems="center"
                justifyContent="center"
            />

            {/* Zoom In/Out Button Group */}
            <ButtonGroup
                variant="solid"
                colorScheme="blue"
                isAttached
                borderRadius="full"
                boxShadow="lg"
                orientation="vertical"
            >
                <IconButton
                    aria-label="Zoom in"
                    icon={<FiPlus size={20} />}
                    onClick={onZoomIn}
                    borderBottomRadius="0"
                    w="40px"
                    h="40px"
                />
                <IconButton
                    aria-label="Zoom out"
                    icon={<FiMinus size={20} />}
                    onClick={onZoomOut}
                    borderTopRadius="0"
                    w="40px"
                    h="40px"
                />
            </ButtonGroup>
        </Flex>
    );
};
